// Sample published lead sources used for preview mode and tests.
// TODO: Revisit once the lead sources read API is available.
export default [
  {
    id: 27342,
    name: 'ApartmentGuide.com',
    label: 'ApartmentGuide.com',
    value: 27342,
  },
  {
    id: 27340,
    name: 'Apartments.com',
    label: 'Apartments.com',
    value: 27340,
  },
  {
    id: 59550,
    name: 'Community Website',
    label: 'Community Website',
    value: 59550,
  },
  {
    id: 63758,
    name: 'Covendor Marketing',
    label: 'Covendor Marketing',
    value: 63758,
  },
];
